import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { acceptInvitation, validateInvitationToken } from "../api/authPasswordApi";
import PasswordSetupForm from "../components/auth/PasswordSetupForm";

const INVALID_LINK_MESSAGE = "This link is invalid or has expired.";

const SetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [loading, setLoading] = useState(Boolean(token));
  const [valid, setValid] = useState(false);
  const [accountEmail, setAccountEmail] = useState("");
  const [accountName, setAccountName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setErrorMessage(INVALID_LINK_MESSAGE);
      setLoading(false);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const body = await validateInvitationToken(token);
        if (!cancelled) {
          setValid(Boolean(body?.success));
          setAccountEmail(body?.email || "");
          setAccountName(body?.displayName || "");
        }
      } catch {
        if (!cancelled) {
          setValid(false);
          setErrorMessage(INVALID_LINK_MESSAGE);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!token || (!loading && !valid)) {
    return (
      <div className="midpoint-app auth-page">
        <div className="auth-login-card panel-card">
          <p className="eyebrow">Midpoint</p>
          <h1>Set password</h1>
          <p className="auth-login-error" role="alert">
            {errorMessage || INVALID_LINK_MESSAGE}
          </p>
          <p className="muted auth-login-footnote">
            <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="midpoint-app auth-page">
        <div className="auth-login-card panel-card">
          <p className="muted">Checking your invitation…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="midpoint-app auth-page">
      <PasswordSetupForm
        title="Set password"
        description="Create your password to activate your Midpoint account."
        accountEmail={accountEmail}
        accountName={accountName}
        submitLabel="Activate account"
        onSubmit={(password) => acceptInvitation(token, password)}
      />
      <p className="muted auth-login-footnote" style={{ textAlign: "center", marginTop: "1rem" }}>
        <Link to="/login">Back to sign in</Link>
      </p>
    </div>
  );
};

export default SetPasswordPage;
